import { Option, Schema as Schema_ } from '@blade/std-lib'
import { RegionKeySchema } from '@root/entities/network/model/solana/zero-slot'
import { ZeroSlotApiKeySchema } from '@root/entities/trade-settings/model'

const TypeSchema = Schema_.Union([
  Schema_.Literal('helius-sender'),
  Schema_.Literal('0slot'),
  Schema_.Literal('custom'),
])

export const Schema = Schema_.Struct({
  type: TypeSchema,
  zeroSlotRegion: Schema_.UndefinedOrFromOptional(RegionKeySchema),
  apiKey: Schema_.UndefinedOrFromOptional(ZeroSlotApiKeySchema),
  customRpcUrl: Schema_.UndefinedOrFromOptional(Schema_.String),
})

const FromJson = Schema_.fromJsonString(Schema)

export interface Snapshot extends Schema_.Schema.Type<typeof Schema> {}

export const fromJson = (json: string) => {
  return Option.getOrUndefined(Schema_.decodeOption(FromJson)(json))
}

export const toJson = (settings: Snapshot) => {
  return Option.getOrUndefined(Schema_.encodeOption(FromJson)(settings))
}

const ByPresetSchema = Schema_.Array(Schema)
const FromJsonByPreset = Schema_.fromJsonString(ByPresetSchema)

export const fromJsonByPreset = (json: string) => {
  return Option.getOrUndefined(Schema_.decodeOption(FromJsonByPreset)(json))
}

export const toJsonByPreset = (settings: Array<Snapshot>) => {
  return Option.getOrUndefined(Schema_.encodeOption(FromJsonByPreset)(settings))
}
